<template>
<b-row class="item-details-container ">
     <b-col>
        <b-list-group-item>
          <a  :href="'#choice-details-'+choice.id" draggable="false"  class='wrapper-a' @click="clickToExpanding" >
            <b-row>
              <b-col class="px-0" cols="2" sm="1">
                <div class="toggle-icon"  @click.prevent>
                  <span v-if="isVisible" aria-hidden="true"><b-icon variant="secondary" icon="caret-right-fill" font-scale="2.2" v-b-popover.hover.left="'View Items'"></b-icon></span>
                  <span v-else aria-hidden="true"><b-icon variant="secondary" icon="caret-down-fill" font-scale="2.2" v-b-popover.hover.left="'View Items'"></b-icon></span>
                </div>
              </b-col>
              <b-col class="pl-0" cols="7" sm="9">
                  <b-form-input v-model="updChoice.name" @change="updateChoice()"></b-form-input>
              </b-col>
              <b-col cols="1" class="pl-0 ml-0">
                <b-form-checkbox v-model="activeChoice" switch @input="updateChoice()">
                  <span v-if="updChoice.active==true">Active</span>
                  <span v-else>Inactive</span>
                </b-form-checkbox>
              </b-col>
            </b-row>
          </a>
          <b-collapse class="category-card" :id="'choice-details-'+choice.id" v-model="isVisible">
            <b-row class="py-2">
              <b-col cols="2" md="1" class="pt-2">
                <label for="cu_add-price" style="float: right;">Price: </label>
              </b-col>
              <b-col cols="4" md="2">
                <b-form-input id="cu_add_price" v-model="updChoice.add_price"></b-form-input>
              </b-col>
              <b-col cols="6" md="9">
                <b-button variant="outline-danger" style="float: right;" @click="confirmChoiceDelete">Delete?</b-button>
                <!-- <a :href="'#'+$route.path">
                  <b-icon icon="x-circle" variant="danger" font-scale="2.5" v-b-popover.hover.right="'Delete Choice'" @click="confirmChoiceDelete"></b-icon>
                </a> -->
              </b-col>
            </b-row>
          </b-collapse>
        </b-list-group-item>
     </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'ChoiceList',
  props: ['choice'],
  data () {
    return {
      updChoice: {
        name: this.choice.name,
        add_price: this.choice.add_price,
        active: this.choice.active
      },
      isVisible:false
    }
  },

  computed: {
    activeChoice: {
      get: function() {
        return this.choice.active;
      },
      set: function(newVal) {
        this.updChoice.active = newVal;
      }
    },
  },

  methods: {
    clickToExpanding(event){
      const currentIsVisible = this.isVisible ;
      const clickedTag = event.target.tagName ;
      console.log(clickedTag);
      if(clickedTag.includes('SPAN') || clickedTag.includes('LABEL') || (clickedTag.includes('INPUT') && event.target.type === 'checkbox' ))
      {
        return ;
      }
      else if(clickedTag.includes('INPUT')|| clickedTag.includes('BUTTON'))
      {
         event.preventDefault();
        this.isVisible = currentIsVisible ;
      }
      else{
        event.preventDefault();
        this.isVisible = !currentIsVisible;
      }

    },
    emitSwitchOverlay(bool) {
      this.$emit('emit-switch-overlay', bool);
    },

    emitFetchChoices() {
      this.$emit('emit-fetch-choices');
    },

    async confirmChoiceDelete() {
      this.confirmDel = ''
      this.$bvModal.msgBoxConfirm('Please confirm that you want to delete choice '+this.choice.name+'!', {
        title: 'Please confirm delete',
        centered: true
      })
      // Confirmed - you can delete the category now!
      .then(value => {
        this.confirmDel = value
        if (this.confirmDel == true) {
          this.deleteChoice();
        }
      })
      // Error processing modal
      .catch(err => {
        console.log('an error has occurred. '+ err)
      })
    },

    async updateChoice() {
      this.emitSwitchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = {
        "name": this.updChoice.name,
        "add_price": this.updChoice.add_price,
        "active": this.updChoice.active
      }
      // update order with status of 'ready'
      const { data } = await this.$api.patch('optionitems/'+this.choice.id,
        body,
        config
      );
      if (data.success == true) {
        this.emitFetchChoices();
      } else {
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem updating the choice, please try again later.', {
          title: 'Error updating choice',
          centered: true
        })
      }
    },

    async deleteChoice() {
      this.emitSwitchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      // update order with status of 'ready'
      const { data } = await this.$api.delete('optionitems/'+this.choice.id,
        config
      );
      if (data.deleted == true) {
        this.emitFetchChoices();
      } else {
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem deleting the choice, please try again later.', {
          title: 'Error deleting choice',
          centered: true
        })
      }
    },

  }
}
</script>

<style scoped>
 .toggle-icon{
   margin : 6px 5px;
 }
  .wrapper-a{
    text-decoration: none;
    color: initial;
  }
  .wrapper-a:hover{
    text-decoration: none;
    color: initial;
  }
  .list-group-item{
    position: relative;
    border: 0.2px solid rgb(238, 238, 238) ;
    margin: 10px 0px;
    border-radius: 6px;
    box-shadow: 0 1px 0px rgb(84 70 35 / 15%), 0 0px 2px 0px rgb(84 70 35 / 15%);
  }
  .list-group-item:hover{
    box-shadow: 0 2px 6px rgb(84 70 35 / 15%), 0 1px 3px rgb(84 70 35 / 15%);
  }

  .item-details-container > .col{
    padding: 0px;
  }
  .draggable-btn{
    position: relative;
    margin: auto 0px;
    cursor: pointer;
  }
  .draggable-btn > * {
    transform: rotateZ(270deg);
  }
  .form-control{
    outline: none;
    border-inline: none;
    border: none;
  }
  .form-control:focus{
    border-color: gray;
    box-shadow: 0 0 0px 1px rgb(109 109 109 / 25%);
    background-color: transparent;
    outline: 0;
  }
</style>
